
































import { Vue, Component, Emit } from 'vue-property-decorator';
import { namespace, State, Action } from 'vuex-class';
import { Button, Swipe, SwipeItem, ImagePreview, Toast } from 'vant';
import VoteButton from '@/components/VoteButton.vue';
import Popup from './components/Popup.vue';
import LikeButton from './components/LikeButton.vue';
import { STOR_NAME } from './api';
import * as config from './config';
import EventsBus from './bus';

const Modules = namespace(STOR_NAME);

Vue.use(Button).use(ImagePreview).use(Swipe).use(SwipeItem).use(Toast);

@Component({
  components: {
    VoteButton,
    Popup,
    LikeButton,
  },
})
export default class DetailPage extends Vue {
  @Modules.State('detailData') 'detailPageData'!: any;
  @Modules.Action fetchDetail!: (val: any) => void;
  @Modules.Action fetchBalance!: () => void;
  @Modules.Action fetchUserInfo!: () => void;
  @Modules.Mutation UPDATE_VOTE_NUM!: (num: any) => void;
  options = config.OPTHINES;
  detailDate = {};
  get queryData() {
    return this.$route.query;
  }
  get images() {
    const res = this.detailPageData.cover;
    return res;
  }

  created() {
    this.fetchDetail(this.queryData);
    this.fetchBalance();
    this.fetchUserInfo();

    window.userInfoChange = () => {
      this.$router.go(0);
      this.fetchUserInfo();
      this.fetchBalance();
    };
  }
  handlePicShow(index: number) {
    ImagePreview({
      images: this.images,
      startPosition: index,
    });
  }
}
